import Gesture from "../../../reusableModules/Gesture";
import common from "../../../common";
import TutorialFinger from "../../../reusableModules/TutorialFinger";
import ParticleEmitter from "../../../reusableModules/ParticleEmitter";

export default class Gesture_Mixing extends PIXI.Container{
    constructor() {
        super();
        this._gesture = null;
        this._allGestures = [];
        this._tutorialFinger = null;
        this._particleEmitter = null;
        this._isDragging = false;
        this._bindings = {};
        this._signals = {};
        this._signals.gestureComplete = new P3.utils.MiniSignal();
        this._signals.gestureCreated = new P3.utils.MiniSignal();
    }

    init() {
        this.createGesture();
        this.createTutorial();
        this.createFingerFollowEmitter();

        this.interactive = true;
        this.on('pointerdown', (event)=>{
            this._isDragging = true;
            if(this._particleEmitter){
                let pos = event.data.getLocalPosition(this);
                this._particleEmitter._emitter.updateOwnerPos(pos.x, pos.y);
                //this._particleEmitter.position.set(pos.x, pos.y);
                this._particleEmitter.play();
            }
            if(this._tutorialFinger)
                this._tutorialFinger.turnOff();
        });
        this.on('pointerup', ()=>{
            this._isDragging = false;
            this._particleEmitter.turnOff();
        });
        this.on('pointerupoutside', ()=>{
            this._isDragging = false;
            this._particleEmitter.turnOff();
        });
        this.on('pointermove', (event)=>{
            if(this._isDragging){
                if(this._particleEmitter){
                    let pos = event.data.getLocalPosition(this);
                    let diffX = this._particleEmitter.x - pos.x;
                    let diffY = this._particleEmitter.y - pos.y;
                    this._particleEmitter._emitter.updateOwnerPos(pos.x, pos.y);
                    //console.log(this._particleEmitter._emitter);
                }
                if(this._tutorialFinger)
                    this._tutorialFinger.turnOff();
            }
        });
    }

    update() {
        if(this._tutorialFinger){
            this._tutorialFinger.update();
        }

        if(this._particleEmitter){
            this._particleEmitter.update();
        }


        if(this._gesture)
            this._gesture.update()


    }

    destroy(){
        for (const i in this._bindings) {
            if (this._bindings.hasOwnProperty(i)) {
                const binding = this._bindings[i];
                binding.detach();
            }
        }
        this._bindings = {};

        this._gestureTween.stop();
        this._gestureIn.stop();
        if(this._particleEmitter){
            this._particleEmitter.destroy();
            this.removeChild(this._particleEmitter);
        }
    }

    createGesture(){
        this.interactive = true;
        let allTextures = ["mix_magic"];
        let allPoints = [];

        let points = [
            new PIXI.Point(200, 56),
            new PIXI.Point(350, 125),
            new PIXI.Point(200, 190),
            new PIXI.Point(45, 125)
        ];
        allPoints.push(points);

        for (let i = 0; i < allPoints.length; i++) {
            let gesture = new Gesture(P3.assets.texture(allTextures[i]), allPoints[i], true);
            gesture.visible = false;
            this.addChild(gesture);
            this._allGestures.push(gesture);
        }

        let selected = common.randomSelection(this._allGestures);
        selected.createPoints(this.tweens, true);
        selected.sprite.scale.set(0.8);
        selected.x = common.STAGE_WIDTH * 0.5 - selected.width * 0.5;
        selected.y = common.STAGE_HEIGHT * 0.5 - selected.height * 0.5;
        selected.addChild(selected._completeSprite);
        selected.visible = true;
        this._gesture = selected;

        this._signals.gestureCreated.dispatch();

        this._bindings.gestureComplete = this._gesture.signals.complete.add(this.onGestureComplete, this);
        this._bindings.gestureStarted = this._gesture.signals.firstTouch.add(()=> {
            if(this._tutorialFinger)
                this._tutorialFinger.turnOff();
        }, this);

        this._gesture.alpha = 0;
        this._gestureIn = new P3.utils.TWEEN.Tween(this._gesture, this.tweens)
            .to({
                alpha: 1
            }, 850)
            .easing(P3.utils.Easing.Back2.Out)
            .start();
    }

    onGestureComplete() {
        if(this._gesture){
            this._gestureTween = new P3.utils.TWEEN.Tween(this._gesture, this.tweens)
                .to({
                    alpha: 0
                }, 850)
                .easing(P3.utils.Easing.Back2.In)
                .onStart(()=>{
                    if (this._allGestures[0] && this._allGestures[0].pointSprites[0])
                    {
                        this._allGestures[0].pointSprites[0].visible = false;
                    }
                })
                .onComplete(()=>{
                    for (let i = 0; i < this._allGestures.length; i++) {
                        let temp = this._allGestures[i];
                        temp.destroy();
                    }
                    this._allGestures = [];
                    this._gesture = null;
                })
                .start();
        }


        this.interactive = false;

        P3.audio.playSound("sfx_stage_complete_00");
        this._signals.gestureComplete.dispatch();
        this._bindings.help.detach();
    }

    createTutorial(){
        if(this._tutorialFinger != null){
            this.removeChild(this._tutorialFinger);
            this._tutorialFinger.destroy();
            this._tutorialFinger = null;
        }

        this._tutorialFinger = new TutorialFinger({
            x: this._gesture.pointSprites[0].x + this._gesture.x + 75,
            y: this._gesture.pointSprites[0].y + this._gesture.y
        }, 10, -1);
        this.addChild(this._tutorialFinger);

        this._tutorialFinger.fade(true, 500, false);
        this._tutorialFinger.clickDown();

        for (let i = 1; i < this._gesture.pointSprites.length; i++) {
            const selectedElement = this._gesture.pointSprites[i];
            if(i === 0) break;

            let tween = new P3.utils.TWEEN.Tween(this._tutorialFinger._view, this.tweens)
                .to({
                    x: selectedElement.x + this._gesture.x + 75,
                    y: selectedElement.y + this._gesture.y
                }, 1000)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);
            this._tutorialFinger.addStep(tween);
        }

        this._tutorialFinger.clickUp();
        this._tutorialFinger.fade(false, 500, false);
        this._tutorialFinger.addDelay(500);
        this._tutorialFinger.play();
    }

    createFingerFollowEmitter(){
        let particles = ParticleEmitter.FINAL_COOKIE_LOOP_00;

        this._particleEmitter = new ParticleEmitter(particles, ParticleEmitter.SPARKLE, true);

        this.addChild(this._particleEmitter);

        this._particleEmitter.enableLoop();

        let config = this._particleEmitter._config;
        config.spawnCircle = {
            "x": 0,
            "y": 0,
            "r": 50
        };
        this._particleEmitter.overrideDefaultConfig(config);
    }
}